import { render, staticRenderFns } from "./ServiceLogAdder.vue?vue&type=template&id=79882b3c&scoped=true&"
import script from "./ServiceLogAdder.vue?vue&type=script&lang=js&"
export * from "./ServiceLogAdder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79882b3c",
  null
  
)

export default component.exports